<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                  
                <div class="row mb-1">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">                        
                        <div ref="pdfContent" class="card mt-4 pdf-table">
                            <div class="card-header">                                
                                <img :src="isLoading ? loadingImageUrl : associationLogoImageSrc" :alt="$t('association.Logo_image')" style="width: 200px;" />
                                <h6 class="mb-2">{{ stableData?.associationName }}</h6>
                                <table>                                            
                                    <tbody>
                                        <tr>
                                            <td style="width:30%; text-align: left; border: none !important; font-size: 15px !important;">
                                                <b>{{ $t('animal.Studbooknumber_keeper')  }}</b>: {{ stableData?.studbookCode }}<br>
                                                <b>{{ $t('location.UBN')  }}</b>: {{ stableData?.locationUBN }}<br>
                                                <b>{{ $t('animal.Location_name')  }} </b>: {{ stableData?.locationName }}
                                            </td>
                                            <td style="border: none !important;"><h3>{{ $t('animal.Stablelist') }}</h3></td>
                                            <td style="width:30%; text-align: right;  border: none !important;font-size: 15px !important;">
                                                <span v-html="stableData?.keeperFullName"></span><br>
                                                <span v-html="stableData?.locationFullAddress"></span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>                                
                            </div>
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-12">
                                        <table id="stableTable" border="1">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Recordnumber') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Studbooknumber') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Tagnumber') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Animal_gender') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Birthdate') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Studbooknumberfather') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.Studbooknumbermother') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.No_of_matings') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('animal.No_of_births') }}</p></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in animalData" v-bind:key="item.id">
                                                    <td class="text-sm font-weight-normal">{{ index + 1 }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.studbooknumber }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.tagnumber }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.animalgender }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.birthdate }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.studbooknumberfather }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.studbooknumbermother }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.noofmatings }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.noofbirths }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>                                
                                </div>                                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 mt-2">
                <router-link to="/location" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                <button v-on:click="downloadPdf" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Download_PDF') }}</button>
            </div>            
        </div>
    </div>        
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf';
import loadingImageUrl from "@/assets/img/LoadingImage.gif";
import autoTable from "jspdf-autotable";

export default {
    name: 'Stablelist_report_page',
    data() {
        return {
            ubnid:'',            
            stabledata: [],
            animalData: [],
            stableData: null,
            associationLogoImageSrc: null,
            isLoading: true,
            loadingImageUrl
        };
    },
    computed: {      
        safeStable() {
            return this.stableData || {};
        }  
    },
    async mounted() 
    {    
        this.ubnid = this.$route.params.id;
        await this.fetchStableData();
    },
    methods: {        
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },
        async fetchAssociationImage(id) {

            try {
            this.isLoading = true;

            try {
                const responseLogo = await axios.get(`association/getassociationlogo/`, {
                params: { associationId: id },
                responseType: 'blob',
                });

                const contentTypeLogo = responseLogo.headers['content-type'];

                if (!contentTypeLogo.startsWith('image/')) {
                    this.associationLogoImageSrc = require('@/assets/no-image.png');
                    return;
                }

                const imageLogoBlob = responseLogo.data;
                this.associationLogoImageSrc = URL.createObjectURL(imageLogoBlob);

            } catch (error) {
                this.associationLogoImageSrc = require('@/assets/no-image.png');
                console.error('Failed to fetch logo image:', error);
            }
            } finally {
                this.isLoading = false; // Set loading state to false after fetching
            }
        },
        async fetchStableData() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("location/stablelist", {
                    params: {
                        ubnId: this.ubnid
                    }
                });                
                const result = response?.data;

                if (result?.success && result?.data) {
                    this.animalData = Array.isArray(result.data.animalsData)
                    ? result.data.animalsData
                    : [];
                    
                    this.stableData = result.data.stableData ?? null;
                                        
                    await this.fetchAssociationImage(this.stableData.associationId);                    
                } else {
                    this.$showSuccess('errors.Error_fetching_stabledata');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }, 
        async downloadPdf() {

            const pdf = new jsPDF('landscape', 'mm', 'a4');

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const headerHeight = 45;

            autoTable(pdf, {

                html: '#stableTable',
                startY: headerHeight + 5,
                theme: 'grid',
                styles: {fontSize: 8, halign: 'center'},
                margin: {top: headerHeight + 5, bottom: 15, left: 10, right: 10},
                
                didDrawPage: () => {

                    if (this.associationLogoImageSrc) {
                        pdf.addImage(this.associationLogoImageSrc, 'PNG', 10, 8, 30, 15);
                    }

                    pdf.setFontSize(11);
                    pdf.text(this.stableData?.associationName || '', 10, 28);

                    pdf.setFontSize(9);
                    pdf.text(`Stamboeknr: ${this.stableData?.studbookCode || ''}`, 10, 34);

                    pdf.text(`UBN: ${this.stableData?.locationUBN || ''}`, 10, 39);

                    pdf.text(`Bedrijfsnaam: ${this.stableData?.locationName || ''}`, 10, 44);

                    pdf.setFontSize(16);
                    pdf.text("Stallijst", pageWidth / 2, 32, { align: "center" });

                    pdf.setFontSize(9);
                    const rightX = pageWidth - 10;

                    const addressLines = [
                        this.stableData?.keeperFullName || '',
                        ...(this.stableData?.locationFullAddress || '').split('<br>')
                    ];

                    let y = 28;

                    addressLines.forEach(line => {
                        const cleanText = line.replace(/<[^>]+>/g, '');
                        pdf.text(cleanText, rightX, y, { align: 'right' });
                        y += 5;
                    });
                }
            });

            const pageCount = pdf.internal.getNumberOfPages();

            for (let i = 1; i <= pageCount; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.text(`Pagina ${i} vaan ${pageCount}`, pageWidth / 2, pageHeight - 5, { align: 'center' });
            }

            pdf.save('Stablelist.pdf');
        }
    }
}
</script>
<style scoped>
    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        border: 1px solid #000; /* Ensures all borders show */
        padding: 8px;
        text-align: center;
        font-size: 12px;
    }

    .pdf-table, 
    .pdf-table * {
        background-color: white !important;
        box-shadow: none !important;
    }

    .card.pdf-table {
        background-color: white !important;
        border: none !important;
    }
    .pdf-table table {
        background: white;
    }
</style>